import { render, staticRenderFns } from "./Inventario.vue?vue&type=template&id=2b03a891&scoped=true&"
import script from "./Inventario.vue?vue&type=script&lang=js&"
export * from "./Inventario.vue?vue&type=script&lang=js&"
import style0 from "./Inventario.vue?vue&type=style&index=0&id=2b03a891&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b03a891",
  null
  
)

export default component.exports